import { Column, ErrorText, LoadingIndicator } from "@/components";
import { JobInterviewsTable } from "@jobs/JobInterviewsTable";

import { useUserSheet } from "@/components/user-sheet/userSheetContext";
import { defaultInterviewQueryParams } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { Job } from "@/types";

export const InterviewsTab = ({
  isError,
  isPending,
  job,
}: {
  isError: boolean;
  isPending: boolean;
  job?: Job;
}) => {
  /* Context */
  const { candidacyId, contentPaddingClassName } = useUserSheet();

  /* Render */
  const render = () => {
    if (isPending) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <LoadingIndicator variant="medium" />
        </Column>
      );
    }
    if (isError || !job || !candidacyId) {
      return (
        <Column className={cn("py-7", contentPaddingClassName)}>
          <ErrorText errorMessage="Error retrieving interviews." />
        </Column>
      );
    }

    return (
      <Column className={cn("py-7", contentPaddingClassName)}>
        <JobInterviewsTable
          interviewQueryParams={{
            ...defaultInterviewQueryParams,
            candidacyId,
          }}
          job={job}
        />
      </Column>
    );
  };

  return render();
};
